<div class="d-flex align-items-center countries-header">
  <h6 *ngIf="layout === 'add_campaign'" class="font700 fontsize10 mb-0">{{ 'view_translations.countries' | translate | uppercase }}</h6>
  <h6 *ngIf="layout === 'traffic_source'" class="font700 fontsize16 mb-0">{{ 'view_translations.destination_group_countries' | translate }}</h6>
  <div
    *ngIf="layout === 'add_campaign'"
    ngbTooltip="{{ 'countries_description_tooltip' | t }}"
    tooltipClass="my-configurations-tooltip"
    container="body"
    class="info-icon-container ms-2">
    <nb-icon icon="info" pack="icomoon"></nb-icon>
  </div>
</div>
<div class="inner-addon searchbar global-transition">
  <nb-icon icon="search" pack="icomoon" class="glyphicon" [ngClass]="{'glyphicon-large' : layout==='traffic_source'}"></nb-icon>
  <input
    placeholder="{{ 'view_translations.search' | translate }}"
    class="form-control border-0 searchbar-input-field btn-default-color"
    [ngClass]="{'searchbar-large' : layout==='traffic_source'}"
    type="search"
    [(ngModel)]="search" />
</div>
<div class="checkboxes-wrapper">
  <h6 class="fontsize13 font500 elements-padding" [ngClass]="{'d-none': selectedCountries.length === 0}">
    {{'view_translations.selected_countries' | translate}}
  </h6>
  <div class="selected-countries-container elements-padding mb-2" [ngClass]="{'d-none': selectedCountries.length === 0, 'extend': expandSelectedCountries}">
    <div class="row">
      <div class="countries-columns" *ngFor="let country of selectedCountries; let i = index">
        <div *ngIf="i % 2 === 0" class="country-column col-12 col-sm-6">
          <app-country-checkbox
            [country]="country"
            [defaultValue]="defaultValue"
            [checkedValues]="checkedValues"
            (emitCheckedCountry)="updateUncheckedValues($event)"
            [hide]="isCountryVisible(i)">
          </app-country-checkbox>
        </div>
        <div *ngIf="i % 2 === 1" class="country-column col-12 col-sm-6">
          <app-country-checkbox
            [country]="country"
            [defaultValue]="defaultValue"
            [checkedValues]="checkedValues"
            (emitCheckedCountry)="updateUncheckedValues($event)"
            [hide]="isCountryVisible(i)">
          </app-country-checkbox>
        </div>
      </div>
    </div>
  </div>
  <p class="expand elements-padding" *ngIf="selectedCountries.length > 10 && !expandSelectedCountries" (click)="expandSelectedCountriesList()">
    {{'view_translations.expand' | translate}} (+{{selectedCountries.length - 10}})
  </p>
  <p class="expand elements-padding" *ngIf="selectedCountries.length > 10 && expandSelectedCountries" (click)="expandSelectedCountriesList()">
    {{'view_translations.hide' | translate}}
  </p>
  <h6 *ngIf="translatedCountries.length > 0" class="fontsize13 font500 elements-padding">{{'view_translations.select_label' | translate}}:</h6>
  <div *ngIf="translatedCountries.length > 0">
    <div class="selected-countries-container elements-padding mb-2">
      <div class="row">
        <div class="countries-columns" *ngFor="let country of (translatedCountries | searchCountry:search | slice: 0 : maxCountries); let i = index">
          <div *ngIf="i % 2 === 0" class="country-column col-sm-6">
            <app-country-checkbox
              [country]="country"
              [defaultValue]="defaultValue"
              [checkedValues]="selectedCountries"
              (emitCheckedCountry)="updateCheckedValues($event)">
            </app-country-checkbox>
          </div>
          <div *ngIf="i % 2 === 1" class="country-column col-sm-6">
            <app-country-checkbox
              [country]="country"
              [defaultValue]="defaultValue"
              [checkedValues]="selectedCountries"
              (emitCheckedCountry)="updateCheckedValues($event)">
            </app-country-checkbox>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<small *ngIf="required && submitted && (this.checkedValues.length < 1)" class="form-text text-danger mb-4">
  {{ 'view_translations.this_field_is_required' | translate }}
</small>
